import {HttpClient, HttpResponse} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LOGBOOK_API} from "../../../app.constants";

@Injectable()
export class PasswordResetInitService {

    constructor(private http: HttpClient) {
    }

    save(form): Observable<HttpResponse<any>> {
        return this.http.post(LOGBOOK_API + '/api/password-reset/init', form, {observe: "response"});
    }
}
